const AnimatedCrossIcon = ({ className, duration = 4000 }) => (
  <svg
    className={className}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M20 20L8 8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 8L8 20"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {duration && (
        <circle
          cx="14"
          cy="14"
          r="13.5"
          stroke="currentColor"
          pathLength={1}
          className="animate-draw-svg-path"
          transform="rotate(-90, 14, 14)"
          style={{
            strokeDasharray: 1.01,
            strokeDashoffset: 1.01,
            animationDuration: `${duration}ms`,
            animationDirection: 'reverse'
          }}
        />
      )}
    </g>
  </svg>
);

export default AnimatedCrossIcon;
